import { render, staticRenderFns } from "./SignUpField.vue?vue&type=template&id=79126cca&"
import script from "./SignUpField.vue?vue&type=script&lang=ts&"
export * from "./SignUpField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports